import { Outlet } from 'react-router';
import { Container, LangButton, ProfileSection } from './AppLayout.styles';
import '../../reset.styles';
import { useTranslation } from 'react-i18next';

interface AppLayoutProps {
  changeLanguage: (language: string) => void;
  locale: string;
  isAuthButtonEnabled?: boolean;
  disableTranslations?: boolean;
}

export const AppLayout = ({ changeLanguage, locale, disableTranslations }: AppLayoutProps) => {
  const { t } = useTranslation('wifi');

  if (disableTranslations) {
    return <Outlet />;
  }

  return (
    <>
      <Container>
        <ProfileSection>
          <LangButton isActive={locale === 'en'} onClick={() => changeLanguage('en')}>
            {t(`langEn`)}
          </LangButton>
          <LangButton isActive={locale === 'ar'} onClick={() => changeLanguage('ar')}>
            {t(`langAr`)}
          </LangButton>
        </ProfileSection>
      </Container>
      <Outlet />
    </>
  );
};
